import api from "./api";
import {
  AnasayfaCreateDTO,
  AnasayfaItem,
  AnasayfaUpdateDTO,
  ApiResponse,
} from "./types";

export const AnasayfaService = {
  gorselListele: async () => {
    const response = await api.get<ApiResponse<AnasayfaItem[]>>(
      "/api/Anasayfa/GorselListele"
    );
    return response.data;
  },

  gorselDetay: async (id: string) => {
    const response = await api.get<ApiResponse<AnasayfaItem>>(
      `/api/Anasayfa/GorselDetay/${id}`
    );
    return response.data;
  },

  gorselEkle: async (data: AnasayfaCreateDTO) => {
    const formData = new FormData();
    formData.append("baslik", data.baslik);
    formData.append("url", data.url);
    formData.append("sira", data.sira.toString());
    formData.append("dosyaEkle", data.dosyaEkle);

    const response = await api.post<ApiResponse<AnasayfaItem>>(
      "/api/Anasayfa/GorselEkle",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  },

  gorselGuncelle: async (data: AnasayfaUpdateDTO) => {
    const formData = new FormData();
    formData.append("id", data.id);
    formData.append("baslik", data.baslik);
    formData.append("url", data.url);
    formData.append("dosya", data.dosya);
    formData.append("dosyaTip", data.dosyaTip);
    formData.append("sira", data.sira.toString());
    if (data.dosyaEkle) {
      formData.append("dosyaEkle", data.dosyaEkle);
    }

    const response = await api.put<ApiResponse<AnasayfaItem>>(
      "/api/Anasayfa/GorselGuncelle",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  },

  gorselSil: async (id: string) => {
    const response = await api.delete<ApiResponse<boolean>>(
      `/api/Anasayfa/GorselSil/${id}`
    );
    return response.data;
  },
};
